import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=16938920&scoped=true&"
import script from "./Channel.vue?vue&type=script&lang=ts&"
export * from "./Channel.vue?vue&type=script&lang=ts&"
import style0 from "./Channel.vue?vue&type=style&index=0&id=16938920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16938920",
  null
  
)

export default component.exports